// extracted by mini-css-extract-plugin
export default {"container":"common_container__koa69","fieldWrapper":"common_fieldWrapper__tDa4U","unit":"common_unit__5SSjO","message":"common_message__gSVSX"};